"use client";

import { Heading, HeadingLevel } from "@ariakit/react";
import cn from "classnames";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

import type { TemplateProps } from ".";

import teaserStyles from "../../Teaser.module.scss";
import teaserTextStyles from "../../TeaserText/TeaserText.module.scss";
import styles from "../TeaserInjectableNative.module.scss";
import { Icon } from "../../../Icon/Icon";
import { TeaserImage } from "../../TeaserImage/TeaserImage";
import { useArticleModalStore } from "../../../../store/useArticleModalStore";

const linkHandler = (link: string) => {
  let correctLink = link;
  let externalLink = true;
  if (link.startsWith("https://omni.se")) {
    externalLink = false;
    correctLink = link.replace("https://omni.se", "");
  }

  return { link: correctLink, externalLink };
};

const NativeClassicTemplate = ({
  ad,
  layout,
  open,
  advertisingConsent,
  modal,
}: TemplateProps) => {
  const { openModal } = useArticleModalStore();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { link, externalLink } = linkHandler(ad.clickUrl);
  return (
    <article
      className={cn([
        teaserStyles.teaserContainer,
        styles.container,
        styles[`container--${layout}`],
        styles[`container-background--nativeClassic`],
      ])}
    >
      <div
        className={cn([
          styles.label,
          styles["label--nativeClassic"],
          styles[`label--${layout}`],
        ])}
      >
        <div>
          <div
            className={cn([
              styles["label-text"],
              styles["label-text--nativeClassic"],
            ])}
          >
            <span className={cn([styles["label-text-vignette"]])}>
              annons ·{" "}
            </span>
            {ad.sponsoredBy}
          </div>
        </div>
        <div
          role="button"
          onClick={(e) => {
            open(e);
          }}
          className={styles.button}
        >
          <Icon
            variant="dots"
            isNative
            size="normal"
            ariaLabel="Inställningar"
          />
        </div>
      </div>
      <Link
        href={link}
        target={externalLink ? "_blank" : "_self"}
        onClick={() => {
          if (advertisingConsent) {
            ad.clickTrackers.map((ct) => fetch(ct));
          }
          openModal(
            searchParams.size > 0 ? `${pathname}?${searchParams}` : pathname,
          );
        }}
        className={teaserStyles.teaserLargeImage}
        prefetch={false}
      >
        <div
          className={cn([
            teaserStyles.teaser,
            teaserStyles["regular"],
            styles.teaser,
            styles[layout],
          ])}
        >
          <HeadingLevel>
            {ad?.image?.url && (
              <TeaserImage
                size={layout}
                imageUrl={ad.image.url}
                style="regular"
                hasPriorityImage
              />
            )}
            <div
              className={cn([
                teaserStyles.teaserContent,
                styles[`content--${layout}`],
              ])}
            >
              <div
                className={cn([
                  teaserStyles["regular"],
                  teaserStyles.teaserTextContent,
                ])}
              >
                <HeadingLevel>
                  <Heading
                    className={cn([
                      styles.title,
                      styles[`title--${layout}`],
                      styles[`title--${layout}--native`],
                    ])}
                  >
                    {ad.title}
                  </Heading>
                </HeadingLevel>
                <p className={cn([styles.text], teaserTextStyles.teaserText)}>
                  {ad.body}
                </p>
              </div>
            </div>
          </HeadingLevel>
        </div>
      </Link>
      {modal}
    </article>
  );
};

export { NativeClassicTemplate };
